import { useState } from 'react'

import { Button } from 'core-components/library/button'
import { ModalDialog } from 'core-components/library/modalDialog'
import { Tooltip } from 'core-components/library/tooltip'
import {
  EditButtonContent,
  IEditButtonContent,
} from 'core-components/sitebuilder/settings/wrapper/flexWrapperHeaderSettings/editButton/EditButtonContent'
import styles from 'core-components/sitebuilder/settings/wrapper/flexWrapperHeaderSettings/FlexWrapperHeaderSettings.module.scss'

export const EditButton = (props: IEditButtonContent) => {
  const [editModalVisible, setEditModalVisible] = useState<boolean>(false)

  return (
    <>
      <Tooltip className={styles.tooltip} tipContent={() => <span>{'Edit Wrapper'}</span>}>
        <Button
          iconButton={'kbase kbase-edit'}
          variant={'text'}
          color={'grey'}
          onClick={() => setEditModalVisible(true)}
        />
      </Tooltip>
      <ModalDialog<IEditButtonContent>
        title={'Wrapper Settings'}
        size={'md'}
        show={editModalVisible}
        onClose={() => setEditModalVisible(false)}
        content={EditButtonContent}
        contentProps={props}
      />
    </>
  )
}
